import styled from 'styled-components'

const ProductListSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
`

const Divider = styled.div`
  width: 100%;
  border-top: 1px solid #e0e0e0;
`

export { ProductListSectionWrapper, Divider }
